module.exports = __webpack_public_path__ + "img/b48c0.d19c6eb2.svg";